import flagAusSvg from '@/assets/icons/flags/australia.svg'
import flagCanadaSvg from '@/assets/icons/flags/canada.svg'
import flagUkSvg from '@/assets/icons/flags/united-kingdom.svg'
import flagUsSvg from '@/assets/icons/flags/united-states.svg'

import {type SupportedCountries} from './country'
import {type SupportedLocales} from './locale'

export interface TelephoneEntry {
  displayNumber: string
  number: string
  image: string
  country: string
  countryCode: SupportedCountries
}

export const TELEPHONE_BY_LOCALE: Record<SupportedLocales, TelephoneEntry> = {
  en_US: {
    displayNumber: '+1 855-SHOP-GPT',
    number: '+18557467478',
    image: flagUsSvg,
    country: 'United States',
    countryCode: 'US',
  },
  en_GB: {
    displayNumber: '+44 7727-247-467',
    number: '+447727247467',
    image: flagUkSvg,
    country: 'United Kingdom',
    countryCode: 'GB',
  },
  en_CA: {
    displayNumber: '+1 782-222-7467',
    number: '+17822227467',
    image: flagCanadaSvg,
    country: 'Canada',
    countryCode: 'CA',
  },
  en_AU: {
    displayNumber: '+61 489-267-467',
    number: '+61489267467',
    image: flagAusSvg,
    country: 'Australia',
    countryCode: 'AU',
  },
}

export const getPhoneInfoByLocale = (locale: SupportedLocales): TelephoneEntry => {
  return TELEPHONE_BY_LOCALE[locale]
}
